// 判断传入的属性是否是当前正在审核的属性
export default function judgeAttrUnderReview(list, attr) {
    if (list.length) {
        let judgeFlag = false;
        list.forEach((modifiy) => {
            if (modifiy.fieldName === attr) {
                judgeFlag = true;
            }
        });
        return judgeFlag;
    } else {
        return false;
    }
}
